import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

export default async function getSchedule(organizationId = '', eventId = '') {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseLeadCollector}/schedule/getSchedule?organizationId=${organizationId}&eventId=${eventId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data?.data;
  } catch (error) {
    console.log('Error getSchedule', error);
    throw error;
  }
}
